import React, {Component} from 'react';
import InactiveDay from "./InactiveDay";
import CommonDay from "./CommonDay";
import {connect} from 'react-redux';
import {url_server} from '../../../constants/server';
import {setDisp, setFetchState, setServiceState} from "../../../actions";

class CalendarRows extends Component {

  constructor() {

    super();

    let disponibilidad = '-';

    let month = this.getCurrentMonth(); // January = 0
    let year = this.getCurrentYear();

    let dataDisp = [];

    for (let i = 1; i <= this.getDaysInThisMonth(); i++) {
      dataDisp.push({dia: i, disponibilidad})
    }

    this.state = {
      month,
      year,
      dataDisp
    };

  }

  componentDidMount = async () => {

    // marcar estado de fetching en true
    this.props.setFetchState({
      fetchingState: true
    });

    // fetch from server
    const fserver = await this.getDataFromServer(this.props.datos);

    // marcar estado de fetching en false
    this.props.setFetchState({
      fetchingState: false
    });

    if (fserver) {
      // set data fetched to store
      this.props.setDisp(fserver);
    }
    else {
      this.props.setServiceState('inactive');
    }

  };

  getDaysInSelectedMonth(year, month){
    return new Date(year, month, 0).getDate();
  }

  getDaysInThisMonth() {
    let now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  }

  getCurrentMonth() {
    let d = new Date();
    return d.getMonth();
  }

  getCurrentYear() {
    let d = new Date();
    return d.getFullYear();
  }

  // obtiene el index del primer dia del mes y anio del state
  getFirstDay() {

    let fd = new Date(this.state.year, this.state.month);

    if (this.props.datos.dataDisp !== []) {
      fd = new Date(this.props.datos.anio, this.props.datos.mes);
    }

    return fd.getDay();

  }

  getAllData(dataDisp, dataStore) {

    let diasTotalesPorMes = 0;
    let result = [];
    let flag1 = true;
    let contador2 = 0;

    if (dataStore) {

      // console.log(dataStore);

      diasTotalesPorMes = this.getDaysInSelectedMonth(dataStore.anio, dataStore.mes+1);

      if (diasTotalesPorMes === dataDisp.data.length) {

        // { hacer proc normal }

        dataDisp = dataDisp.length === 0 ? this.state.dataDisp : dataDisp.data;

        let dia_semana = 0;

        for (let item of dataDisp) {

          // completar primeros dias del mes
          if (flag1) {

            let fd = this.getFirstDay();

            if (fd === 0) {
              fd = 7;
            }

            for (let a = 0; a < fd - 1; a++) {

              dia_semana = a;

              result.push(
                <InactiveDay dia_semana={dia_semana} key={'i-' + a}/>
              );
            }

            flag1 = false;
          }

          dia_semana++;

          result.push(
            <CommonDay
              datos={this.props.datos}
              dia={item.dia}
              dia_semana={dia_semana}
              disponibilidad={item.disponibilidad}
              key={item.dia}
            />
          );

          if (dia_semana > 6) {
            dia_semana = 0;
          }


        }

        // Completar los dias restantes
        const resto = result.length % 7;
        const completo = 7 - resto;

        for (let a = 0; a < completo; a++) {

          dia_semana++;

          result.push(
            <InactiveDay dia_semana={dia_semana} key={'if-' + a}/>
          );


        }

      }
      else {

        // caso contrario, completar
        let diasDelMes = [];
        for (let it = 1; it <= diasTotalesPorMes; it++) {
          diasDelMes.push({
            dia: it,
            disponibilidad: '-'
          });
        }

        dataDisp = dataDisp.length === 0 ? this.state.dataDisp : dataDisp.data;

        let dia_semana = 0;

        for (let item of diasDelMes) {

          // completar primeros dias del mes (CASILLAS EN BLANCO)
          if (flag1) {

            let fd = this.getFirstDay();

            if (fd === 0) {
              fd = 7;
            }

            for (let a = 0; a < fd - 1; a++) {

              dia_semana = a;

              result.push(
                <InactiveDay dia_semana={dia_semana} key={'i-' + a}/>
              );
            }

            flag1 = false;
          }

          dia_semana++;

          if (item.dia === dataDisp[contador2].dia) {

            result.push(
              <CommonDay
                datos={this.props.datos}
                dia={dataDisp[contador2].dia}
                dia_semana={dia_semana}
                disponibilidad={dataDisp[contador2].disponibilidad}
                key={dataDisp[contador2].dia}
              />
            );

            contador2++;
          }
          else {
            result.push(
              <CommonDay
                datos={this.props.datos}
                dia={item.dia}
                dia_semana={dia_semana}
                disponibilidad={item.disponibilidad}
                key={item.dia}
              />
            );
          }


          if (dia_semana > 6) {
            dia_semana = 0;
          }

        }

        // Completar los dias restantes (CASILLAS EN BLANCO)
        const resto = result.length % 7;
        const completo = 7 - resto;

        for (let a = 0; a < completo; a++) {

          dia_semana++;

          result.push(
            <InactiveDay dia_semana={dia_semana} key={'if-' + a}/>
          );


        }

      }

    }

    return result;

  }

  getWeeksInMonth(year, month) {

    // url : https://gist.github.com/markthiessen/3883242#gistcomment-3144319

    const daysName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const weeks=[];
    const  lastDate = new Date(year, month + 1, 0);

    let start=0;
    let end;

    for (let i = 1; i < lastDate.getDate()+1; i++) {
      if (daysName[Number(new Date(year, month, i).getDay())] ==="Sunday" || i === lastDate.getDate()) {
        end= i;
        weeks.push({
          start:start+1,
          end:end
        });
        start = i;
      }
    }
    // console.log(weeks);
    return weeks.length;
  }

  getAvailability(datos) {

    let result = [];

    if (datos.dataDisp.length === 0) {

      const availableDays = this.getAllData([], null);
      let i = 0;

      for (let aa = 0; aa < this.getWeeksInMonth(this.state.year, this.state.month); aa++) {

        result.push(
          <section className="calendar-row" key={'s-' + i + '-' + (i + 7)}>
            {availableDays.slice(i, i + 7)}
          </section>
        );

        i += 7;

      }

    }
    else {

      const availableDays = this.getAllData(datos.dataDisp, datos);
      let i = 0;

      for (let aa = 0; aa < this.getWeeksInMonth(datos.anio, datos.mes); aa++) {

        result.push(
          <section className="calendar-row" key={'s-' + i + '-' + (i + 7)}>
            {availableDays.slice(i, i + 7)}
          </section>
        );

        i += 7;

      }

    }

    return result;

  }

  async getDataFromServer(datos) {

    let data = null;

    try {
      const res = await fetch(`${url_server}/boleto/disponibilidad`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          "idRuta": datos.idRuta,
          "mes": datos.mes + 1, // el mes es del 1 al 12 en el server
          "anio": datos.anio
        })
      });

      data = await res.json();

      return data;

    } catch (e) {
      console.error(e);
      return data;
    }

  }

  render() {

    const availability = this.getAvailability(this.props.datos);

    return (
      <div>
        {availability}
      </div>
    );

  }
}

const mapDispatchToProps = dispatch => ({
  setDisp: value => dispatch(setDisp(value)),
  setServiceState: value => dispatch(setServiceState(value)),
  setFetchState: value => dispatch(setFetchState(value))
});

export default connect(null, mapDispatchToProps)(CalendarRows);
